//import { MessageBox, Message } from 'element-ui'
//import ClassicEditor from "@ckeditor/ckeditor5-build-inline";
// var ClassicEditor = new Worker('../../../node_modules/@ckeditor/ckeditor5-build-inline');
// ClassicEditor.onmessage = function (event) {
//   console.log( event,"Called back by the worker!\n");
// };

const state = {
  cardLoading: true, //答题卡本页loading
  boxLoading: true, //弹框loading
  pageCellNum: 0, //多少页，页数个数,页数2从1开始
  pageCellNumCode: ['000', '001', '010', '011', '0100', '0101', '0110', '0111'], //页码二进制点
  pageCellSize: [706, 505], //1.2栏794,3栏552;一二栏留两边距44，三栏首页左边44右边3，结束页左边3右边22，中间页两边两距22
  pageCellData: [],
  answerSheetDefault: {
    acCardName: '答题卡',
    acCardPanes: 1, //布局：1、一栏，2、二栏，3三栏
    acCardYJType: 1, //评阅方式：1、手批，2网阅
    acCardStudentCodeType: 0, //考号填写模式：0-填涂考号， 1-条码 ，2-手写考号
    acCardExamNumber: 8, //考号位数
    acCardMissSign: true, //缺考标记：显示-true，隐藏-false
    acCardHideScore: false, //隐藏分值：显示-true，隐藏-false
    acCardHideOrCode: true, //隐藏二维码：显示-true，隐藏-false
    acCardPint: false, //单面打印：1-单面  2-双面
    acCardABSet: false, //AB卷：开启-true，关闭-false
    acKmCode: '', // 科目
    acPeriod:'', // 年级
    // abPaperModel: ['1'], //答案内AB卷设置
  }, //答卷设置默认值
  answerSheet: {
    acCardName: '答题卡',
    acCardPanes: 1, //布局：1、一栏，2、二栏，3三栏
    acCardYJType: 1, //评阅方式：1、手批，2网阅
    acCardStudentCodeType: 0, //考号填写模式：0-填涂考号， 1-条码 ，2-手写考号
    acCardExamNumber: 8, //考号位数
    acCardMissSign: true, //缺考标记：显示-true，隐藏-false
    acCardHideScore: false, //隐藏分值：显示-true，隐藏-false
    acCardHideOrCode: true, //隐藏二维码：显示-true，隐藏-false
    acCardPint: false, //单面打印：1-单面  2-双面
    acCardABSet: false, //AB卷：开启-true，关闭-false
    // abPaperModel: ['1'], //答案内AB卷设置
  }, //答卷设置
  objectiveFrom: {
    tihao: '',
    timuName: '选择题',
    tixing: '',
    tihaoS: '',
    tihaoE: '',
    fenshuo: '',
    xuanxiang: 4, //默认4个选项
    bufen: '',
    list: [],
    fsTotal: 0, //总分
    groupHArry: [], //每组的个数，高度，内容
    rowNum: 5, //一组默认5题显示
    diffLayout: false, //横竖排
    dingwei: null, //定位
  }, //客观题设置弹框
  fillFrom: {
    tihao: '',
    timuName: '填空题',
    tihaoS: '',
    tihaoE: '',
    fenshuo: '',
    fillNum: 1, //默认一题显示一个空位
    list: [],
    fsTotal: 0, //总分
    groupHArry: [],
    rowNum: 0.2, //一组默认有两个填空题一个填空题占其宽度为1/2
    scoreBor: false,
    placeW: 0, //一个空格的占位符宽度
    dingwei: null, //定位
  }, //填空题设置弹框
  answerFrom: {
    tihao: '',
    timuName: '解答题',
    tihaoS: '',
    tihaoE: '',
    fenshuo: '',
    list: [],
    fsTotal: 0, //总分
    groupHArry: [],
    rowNum: 1,
    dingwei: null, //定位
  },
  writingEnFrom: {
    tihao: '',
    timuName: '英语题',
    tihaoS: '',
    fenshuo: '',
    list: [],
    fsTotal: 0, //总分
    groupHArry: [],
    rowNum: 8, //默认8行
    sty: 0,
    place: '',
    dingwei: null, //定位
  },
  writingFrom: {
    tihao: '',
    timuName: '语文作文题',
    tihaoS: '',
    fenshuo: '',
    list: [],
    fsTotal: 0, //总分
    groupHArry: [],
    rowNum: 1000, //默认1000个字
    isNumPos: 1,
    dingwei: null, //定位
  },
  chooseFrom: {
    tihao: '',
    timuName: '选做题',
    tihaoS: '',
    tihaoE: '',
    fenshuo: '',
    list: [],
    fsTotal: 0, //总分
    groupHArry: [],
    rowNum: 1,
    dingwei: null, //定位
  },
  topicStoreroom: [], //所有题库集合结构
  topicTh: {
    bigTh: [], //大题题号
    smallTh: [], //小题题号
  }, //所有题号集合
  editorConfigData: {
    //editor: ClassicEditor,
    editorData: '',
    editorConfig: {
      //plugins: [ heightline],
      toolbar: [
        // "heading",
        //"heightline",
        'Bold',
        'Italic',
        'Underline',
        'Alignment',
        'Subscript',
        'Superscript',
        'SpecialCharacters',
        //"SpecialCharactersCurrency",
        //"SpecialCharactersMathematical",
        'MathType',
        'Link',
        'BlockQuote',
        'BulletedList',
        'NumberedList',
        'ImageUpload',
        'InsertTable',
        'Undo',
        'Redo',
      ],
      heading: {
        options: [
          { model: 'paragraph', title: '标准', class: 'ck-heading_paragraph' },
          {
            model: 'heading1',
            view: 'h1',
            title: 'h1',
            class: 'ck-heading_heading1',
          },
          {
            model: 'heading2',
            view: 'h2',
            title: 'h2',
            class: 'ck-heading_heading2',
          },
        ],
      },
    },
  }, //编辑器
  objectiveDV: false, //客观题弹框
  fillDV: false, //填空题弹框
  answerDV: false, //解答题
  chooseDV: false, //选做题
  writingEnDV: false, //
  writingDV: false,
  isBoxEdit: false, //每个盒子是否是编辑状态
  allIndex: null,
};

const mutations = {
  boxLoadingMut: (state, log) => {
    state.boxLoading = log;
  },
  cardLoadingMut: (state, log) => {
    state.cardLoading = log;
  },
  pageCellNumMut: (state, log) => {
    state.pageCellNum = log;
  },
  answerSheetMut: (state, log) => {
    state.answerSheet = Object.assign({}, state.answerSheet, log);
  },
  pageCellDataMut: (state, log) => {
    state.pageCellData = log;
  },
  pageCellDataMoveMut: (state, log) => {
    if (state.pageCellData[log.i].content[log.ci].types == 3) {
      state.pageCellData[log.i].content[log.ci].typesItem.groupHArry[log.gi].isMoveP = log.isMoveP;
      state.pageCellData[log.i].content[log.ci].typesItem.groupHArry[log.gi].isMoveN = log.isMoveN;
    } else {
      state.pageCellData[log.i].content[log.ci].isMoveP = log.isMoveP;
      state.pageCellData[log.i].content[log.ci].isMoveN = log.isMoveN;
    }
    //state.pageCellData[log.i].content[log.ci].typesItem.groupHArry
  },
  pageCellNumCodeMut: (state, log) => {
    //cur.toString(2)
    state.pageCellNumCode = log;
  },
  objectiveFromMut: (state, log) => {
    //state.objectiveFrom = log
    if (JSON.stringify(log) == '{}') {
      state.objectiveFrom = {
        tihao: '',
        timuName: '选择题',
        tixing: '',
        tihaoS: '',
        tihaoE: '',
        fenshuo: '',
        xuanxiang: 4,
        bufen: '',
        list: [],
        fsTotal: 0,
        groupHArry: [], //每组的个数，高度，内容
        rowNum: 5, //一组默认5题显示
        diffLayout: false, //横竖排
        dingwei: null, //定位
      };
      return;
    }
    state.objectiveFrom = Object.assign({}, state.objectiveFrom, log);
  },
  fillFromMut: (state, log) => {
    if (JSON.stringify(log) == '{}') {
      state.fillFrom = {
        tihao: '',
        timuName: '填空题',
        tihaoS: '',
        tihaoE: '',
        fenshuo: '',
        fillNum: 1, //默认一题显示一个空位
        list: [],
        fsTotal: 0, //总分
        groupHArry: [],
        rowNum: 0.2, //一组默认有两个填空题一个填空题占其宽度为1/2
        scoreBor: false,
        placeW: 0, //一个空格的占位符宽度
        dingwei: null, //定位
      };
      return;
    }
    state.fillFrom = Object.assign({}, state.fillFrom, log);
  },
  answerFromMut: (state, log) => {
    if (JSON.stringify(log) == '{}') {
      state.answerFrom = {
        tihao: '',
        timuName: '解答题',
        tihaoS: '',
        tihaoE: '',
        fenshuo: '',
        list: [],
        fsTotal: 0, //总分
        groupHArry: [],
        rowNum: 1,
        dingwei: null, //定位
      };
      return;
    }
    console.log(log, 'log');
    state.answerFrom = Object.assign({}, state.answerFrom, log);
  },
  writingEnFromMut: (state, log) => {
    if (JSON.stringify(log) == '{}') {
      state.writingEnFrom = {
        tihao: '',
        timuName: '英语题',
        tihaoS: '',
        fenshuo: '',
        list: [],
        fsTotal: 0, //总分
        groupHArry: [],
        rowNum: 8, //默认8行
        sty: 0,
        place: '',
        dingwei: null, //定位
      };
      return;
    }
    console.log(log, 'log');
    state.writingEnFrom = Object.assign({}, state.writingEnFrom, log);
  },
  writingFromMut: (state, log) => {
    if (JSON.stringify(log) == '{}') {
      state.writingFrom = {
        tihao: '',
        timuName: '语文作文题',
        tihaoS: '',
        fenshuo: '',
        list: [],
        fsTotal: 0, //总分
        groupHArry: [],
        rowNum: 1000, //默认1000个字
        isNumPos: 1,
        dingwei: null, //定位
      };
      return;
    }
    console.log(log, 'log');
    state.writingFrom = Object.assign({}, state.writingFrom, log);
  },
  chooseFromMut: (state, log) => {
    if (JSON.stringify(log) == '{}') {
      state.chooseFrom = {
        tihao: '',
        timuName: '选做题',
        tihaoS: '',
        tihaoE: '',
        fenshuo: '',
        list: [],
        fsTotal: 0, //总分
        groupHArry: [],
        rowNum: 1,
        dingwei: null, //定位
      };
      return;
    }
    console.log(log, 'log');
    state.answerFrom = Object.assign({}, state.answerFrom, log);
  },
  topicStoreroomMut: (state, log) => {
    // if (log.list) {
    //   state.topicStoreroom.splice(log.start, log.delNum, log.list)
    // } else {
    //   state.topicStoreroom.splice(log.start, log.delNum)
    // }
    state.topicStoreroom.splice(log.start, log.delNum, log.list);
    console.log(state.topicStoreroom, 'topicStoreroomMut');
  },
  topicThMut: (state, log) => {
    if (log.isAdd) {
      state.topicTh.bigTh = Array.from(new Set(state.topicTh.bigTh.concat(log.bigTh)));
      state.topicTh.smallTh = Array.from(new Set(state.topicTh.smallTh.concat(log.smallTh)));
    } else {
      for (let b = 0; b < state.topicTh.bigTh.length; b++) {
        if (log.bigTh == state.topicTh.bigTh[b]) {
          state.topicTh.bigTh.splice(b, 1);
        }
      }
      for (let s = 0; s < state.topicTh.smallTh.length; s++) {
        log.smallTh.forEach(st => {
          if (st == state.topicTh.smallTh[s]) {
            state.topicTh.smallTh.splice(s, 1);
          }
        });
      }
    }
    console.log(state.topicTh, 'state.topicTh');
  },
  objectiveDVMut: (state, log) => {
    state.objectiveDV = log;
  }, //客观题弹框
  fillDVMut: (state, log) => {
    state.fillDV = log;
  }, //填空题弹框
  answerDVMut: (state, log) => {
    state.answerDV = log;
  }, //解答题
  chooseDVMut: (state, log) => {
    state.chooseDV = log;
  }, //选做题
  writingEnDVMut: (state, log) => {
    state.writingEnDV = log;
  }, //作文
  writingDVMut: (state, log) => {
    state.writingDV = log;
  }, //作文
  isBoxEditMut: (state, log) => {
    state.isBoxEdit = log;
  }, //作文
  allIndexMut: (state, log) => {
    state.allIndex = log;
  },
};

const actions = {};

// getters
const getters = {
  // pageCellNum:state => state.pageCellNum,
  // cartProducts: (state, getters, rootState) => {
  //   return state.items.map(({ id, quantity }) => {
  //     const product = rootState.products.all.find(product => product.id === id)
  //     return {
  //       title: product.title,
  //       price: product.price,
  //       quantity
  //     }
  //   })
  // },
};

export default {
  namespaced: true, //命名空间
  state,
  getters,
  actions,
  mutations,
};
